/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Today_RestInputs */

const en_us2_native_release_widget_today_rest = /** @type {(inputs: Native_Release_Widget_Today_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest day`)
};

const pt_br2_native_release_widget_today_rest = /** @type {(inputs: Native_Release_Widget_Today_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia de descanso`)
};

const pt_pt2_native_release_widget_today_rest = /** @type {(inputs: Native_Release_Widget_Today_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia de descanso`)
};

/** @type {(inputs: Native_Release_Widget_Today_RestInputs) => LocalizedString} */
const es_419_native_release_widget_today_rest = en_us2_native_release_widget_today_rest;

/** @type {(inputs: Native_Release_Widget_Today_RestInputs) => LocalizedString} */
const fr_fr2_native_release_widget_today_rest = en_us2_native_release_widget_today_rest;

/** @type {(inputs: Native_Release_Widget_Today_RestInputs) => LocalizedString} */
const de_de2_native_release_widget_today_rest = en_us2_native_release_widget_today_rest;

/** @type {(inputs: Native_Release_Widget_Today_RestInputs) => LocalizedString} */
const it_it2_native_release_widget_today_rest = en_us2_native_release_widget_today_rest;

/**
* | output |
* | --- |
* | "Rest day" |
*
* @param {Native_Release_Widget_Today_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_today_rest = /** @type {((inputs?: Native_Release_Widget_Today_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Today_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_today_rest(inputs)
	if (locale === "es-419") return es_419_native_release_widget_today_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_today_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_today_rest(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_today_rest(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_today_rest(inputs)
	return en_us2_native_release_widget_today_rest(inputs)
});
export { native_release_widget_today_rest as "native-release.widget_today_rest" }